import React from 'react';
import { Link } from 'react-router-dom';
import { useStyles } from './styles';
import { Button } from '@mui/material';

const Page404 = () => {
  const classes = useStyles();
  console.log('welcome to 404');
  return (
    <div className={classes.page_background}>
      <div className={classes.page_main_form}>
        <div className={classes.header_main}>
          <h3 className={classes.header_text}>We could not find what you were looking for!</h3>
        </div>
        <div className={classes.header_title}>
          <p className={classes.header_title_text}>We apologize, but these things do happen.</p>
        </div>
        <div className={classes.btn_container}>
          <Link to="/">
            <Button className={classes.btn_home}> Return to Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Page404;
